import { UserCircleIcon } from '@heroicons/react/16/solid';
import { Avatar } from 'antd';
interface ImageProps {
    avatar_src: string;
    isImageRender: boolean;
}
export function Image({ avatar_src, isImageRender }: ImageProps) {
    return (
        <>
            {isImageRender ? (
                <Avatar src={avatar_src} className="cursor-pointer" />
            ) : (
                <UserCircleIcon
                    width={32}
                    height={32}
                    className="text-[#4c4c4c] cursor-pointer"
                />
            )}
        </>
    );
}
